import React from 'react';

import { formatMoney } from '@betterment/js-runtime';
import { Box, Icon, Text } from '@betterment/samba-react';
import { HR } from '@betterment/style-closet-react';

import { ThemedImage } from '../../Shared/components-v2/themed-image/ThemedImage';
import { locationAssign } from '../../Shared/path-helpers';
import { urlBuilder } from '../../Shared/urlBuilder';
import { DeferralSetting } from '../data';

const FourOhOneKAccount: React.FC<{
  deferralSetting: DeferralSetting;
  shouldShowHelpText: boolean;
}> = ({ deferralSetting, shouldShowHelpText }) => {
  return (
    <Box key={deferralSetting.id}>
      <HR />
      <Box
        css={{
          alignItems: 'center',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          mb: 'space.300',
          mt: 'space.300',
        }}
        onClick={() => {
          locationAssign(
            urlBuilder.appDeferralSetting.absolute({
              legalAccountId: deferralSetting.legacyId,
              return_to: window.location.pathname + window.location.search,
            })
          );
        }}
      >
        <Box
          css={{
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <ThemedImage
            themedAsset={deferralSetting.account.goal.icon}
            alt="Goal Icon"
            css={{
              width: { base: 'size.600', md: 'size.600' },
              height: { base: 'size.600', md: 'size.600' },
              marginRight: 'space.200',
            }}
          />
          <Box>
            <Box>{deferralSetting.account.displayName}</Box>
            <Box>
              {!shouldShowHelpText && (
                <Text color="text.weak" variant="text50">
                  {formatMoney(deferralSetting.account.anticipatedBalance)}
                </Text>
              )}
              {shouldShowHelpText && (
                <Text color="text.weak" variant="text50">
                  {deferralSetting.taxBenefitsExplanation}
                </Text>
              )}
            </Box>
          </Box>
        </Box>

        <Box
          css={{
            alignItems: 'center',
            display: 'flex',
          }}
        >
          {!shouldShowHelpText && (
            <Box
              css={{
                alignItems: 'end',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {deferralSetting.value.__typename === 'PayrollContributionConfigValueAmount' && (
                <Box>
                  <Text>{formatMoney(deferralSetting.value.amount)}</Text>
                </Box>
              )}
              {deferralSetting.value.__typename === 'PayrollContributionConfigValuePercent' && (
                <Box>
                  <Text>{deferralSetting.value.percent}%</Text>
                </Box>
              )}
              <Box>
                <Text color="text.weak" variant="text50">
                  per pay period
                </Text>
              </Box>
            </Box>
          )}
          <Box>
            <Icon name="CaretRight" size="small" color="icon" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FourOhOneKAccount;
